import { render, staticRenderFns } from "./SalesIframe.vue?vue&type=template&id=7e345fb3&"
import script from "./SalesIframe.vue?vue&type=script&lang=ts&"
export * from "./SalesIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports